<template>
  <form class="form" novalidate="novalidate">
    <!--begin::Input group-->
    <div class="mb-8">
      <!--begin::Label-->
      <label class="form-label fw-semi-bold required">Name</label>
      <!--end::Label-->
      <!--begin::Input-->
      <input
        v-model="form.name"
        :class="['form-control form-control-solid', validateModel($v.form.name.$error)]"
        type="text"
        placeholder="Enter Unit Name"
      />
      <!--end::Input-->
    </div>
    <!--end::Input group-->
    <!--begin::Actions-->
    <div class="d-flex flex-stack">
      <px-btn color="light" extended-classes="btn-active-light-primary me-2" @click.native="close">Cancel</px-btn>
      <px-btn :in-process="createInProcess" :disabled="createInProcess" @click.native="onSubmit">Create </px-btn>
    </div>
    <!--end::Actions-->
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

import AddUnitMixin from '@/mixins/AddUnitMixin';

export default {
  mixins: [AddUnitMixin],
  data() {
    return {
      createInProcess: false,
    };
  },
  computed: {
    ...mapGetters({
      message: 'units/message',
    }),
  },
  methods: {
    ...mapActions({
      create: 'units/create',
    }),
    ...mapMutations({
      setUnits: 'units/SET_UNITS',
    }),
    async initForm() {
      await this.v_toast(this.message?.status, 'Created successfully!');
      await this.$v.form.$reset();
      this.defaultValues();
      this.$emit('onClose', true);
    },
    close() {
      this.defaultValues();
      this.$emit('onClose', true);
    },
    async onSubmit() {
      this.$v.form.$touch();

      if (this.$v.form.$anyError) {
        return false;
      }

      this.createInProcess = true;

      let data = this.form;

      const newUnit = await this.create(data.name);

      this.$emit('unit-added', newUnit.data.data);

      this.createInProcess = false;

      await this.initForm();
    },
  },
};
</script>
